import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Tiles from '../components/tiles';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Tiles sx={{
      py: 6,
      p: {
        m: 0
      },
      blockquote: {
        m: 0,
        p: 0,
        fontWeight: 'bold'
      },
      a: {
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          color: 'primary'
        }
      }
    }} mdxType="Tiles">
      <ul>
        <li parentName="ul">
          <blockquote parentName="li">
            <p parentName="blockquote">{`“Looking into Theme UI and WHOA 🤯 it's everything I like from styled-system, leveraged into a less opinionated usage.”`}</p>
          </blockquote>
          <p parentName="li">{`– `}<a parentName="p" {...{
              "href": "https://mobile.twitter.com/ekafyi/status/1145298381142540288"
            }}>{`Eka`}</a></p>
        </li>
        <li parentName="ul">
          <blockquote parentName="li">
            <p parentName="blockquote">{`“Feels like web development using cheat codes”`}</p>
          </blockquote>
          <p parentName="li">{`– `}<a parentName="p" {...{
              "href": "https://mobile.twitter.com/rjgux/status/1146490079482929158"
            }}>{`Richard George`}</a></p>
        </li>
        <li parentName="ul">
          <blockquote parentName="li">
            <p parentName="blockquote">{`“Theme UI is brilliant. Took me a little while to get into it but it’s super brill brills once you get going! 😎”`}</p>
          </blockquote>
          <p parentName="li">{`– `}<a parentName="p" {...{
              "href": "https://mobile.twitter.com/PaulieScanlon/status/1146856787494260737"
            }}>{`Paul Scanlon`}</a></p>
        </li>
        <li parentName="ul">
          <blockquote parentName="li">
            <p parentName="blockquote">{`“Took me approximately 5 minutes to fall in love with Theme UI, its sx prop gives you access to design tokens from a theme file automatically as well as the goodness of the css prop 🔥”`}</p>
          </blockquote>
          <p parentName="li">{`– `}<a parentName="p" {...{
              "href": "https://mobile.twitter.com/gill_kyle/status/1144675802002292736"
            }}>{`Kyle Gill`}</a></p>
        </li>
        <li parentName="ul">
          <blockquote parentName="li">
            <p parentName="blockquote">{`“Theme UI is absolutely brilliant. Things I was struggling with in styled-system (like mixing responsive and css props) are solved very elegantly + so much more.”`}</p>
          </blockquote>
          <p parentName="li">{`– `}<a parentName="p" {...{
              "href": "https://mobile.twitter.com/bernharduw/status/1147047566019899392"
            }}>{`Bernhard Gschwantner`}</a></p>
        </li>
      </ul>
    </Tiles>
    {
      /*
      - > Maybe my favorite feature of Theme-UI, responsive styles by passing an array of values that map to your theme's breakpoints:
       > I've never figured out media-queries but this finally makes sense 🙌
       [Kyle Gill](https://mobile.twitter.com/gill_kyle/status/1146099033875681280)
      - > I think Gatsby theme is really great idea... my favorite part is that they folded themes under plugin and extracted out the idea of shadowing and theme-ui. This is quickly becoming one of my favorite frameworks!
       [Ken](https://mobile.twitter.com/kenneth_chau/status/1147039617784279040)
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      